import { reactive, ref, computed, onMounted } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'
import * as CommonInquiry from '@/logic/common/CommonInquiry'
import * as common from '@/util/common'
import * as apiInquiry from '@/api/inquiry'

/**
 * 入力画面
 */
export const getGroupIndex = () => {

  const group1 = reactive({

    device: computed(() => {
      return store.state.common.device
    }),

    // フォーム入力値
    name: '',
    kana: computed(CommonInquiry.computedH2Z('kana')),
    charge_name: '',
    department: '',
    postnumber: computed(CommonInquiry.computedZ2H('postnumber')),
    address: computed(CommonInquiry.computedH2Z('address')),
    address2: computed(CommonInquiry.computedH2Z('address2')),
    address3: computed(CommonInquiry.computedH2Z('address3')),
    address4: computed(CommonInquiry.computedH2Z('address4')),
    email: computed(CommonInquiry.computedZ2H('email')),
    email_check: computed(CommonInquiry.computedZ2H('email_check')),

    occupation_classification: '', // 職業区分コード(文字列)
    occupation: '', // 業種・職業コード(文字列)

    // 職業選択肢(プルダウン)生成用リスト
    occupationClassificationList: [],

    // 選択された職業区分
    selectedOccupationClassificationName: computed(() => {
      return CommonInquiry.getSelectedOccupationClassificationName(group1, '業種を選んでください')
    }),

    // 業種・職業名の選択肢(プルダウン)用リスト
    occupationList: computed(() => {
      return CommonInquiry.getOccupationList(group1)
    }),

    // 選択された業種・職業名
    selectedOccupationName: computed(() => {
      return CommonInquiry.getSelectedOccupationName(group1, '職業を選んでください')
    }),

    tel: computed(CommonInquiry.computedZ2H('tel')),
    tel2: computed(CommonInquiry.computedZ2H('tel2')),
    extension: computed(CommonInquiry.computedZ2H('extension')),
    fax: computed(CommonInquiry.computedZ2H('fax')),
    message_type: '',
    message: '',

    // 入力エラーフラグ
    isError: false,

    // フォーム入力エラーメッセージ
    error_name: '',
    error_kana: '',
    error_charge_name: '',
    error_department: '',
    error_postnumber: '',
    error_address: '',
    error_address2: '',
    error_address3: '',
    error_address4: '',
    error_email: '',
    error_email_check: '',
    error_occupation_classification: '',
    error_occupation: '',
    error_tel: '',
    error_tel2: '',
    error_extension: '',
    error_fax: '',
    error_message_type: '',
    error_message: '',

    // 住所エリア表示状態
    visibleAddress: computed(() => {
      return store.state.inquiry.isAddressAreaVisible
    }),

    // 住所選択ダイアログ表示フラグ
    visiblePostnumberDuplicated: false,

    // 重複した住所のリスト
    duplicatedAddressList: [],

    // 職業（区分）プルダウンの表示フラグ
    displayOccupationClassificationSelect: false,
    //　職業（業種・職業）プルダウンの表示フラグ
    displayOccupationSelect: false,

    // お問い合わせタイププルダウン
    isVisibleTypeList: false,
    currentTypeValue: 0,
    listTypeItem: [
      {
        value: 0, 
        label: '選択してください'
      },
      {
        value: 1, 
        label: 'トライアルお申込・ご契約について'
      },
      {
        value: 2, 
        label: 'ご利用方法について'
      },
      {
        value: 5, 
        label: '自動決済について'
      },
      {
        value: 3, 
        label: 'その他について'
      }
    ],

    // 送信中フラグ（二重送信防止用）
    isProcessing: false,

    /**
     * 初期表示
     */
    init: () => {
      // 確認画面から戻ってきた場合、ストアからデータをロード
      group1.name = store.state.inquiry.name ?? ''
      group1.kana = store.state.inquiry.kana ?? ''
      group1.charge_name = store.state.inquiry.charge_name ?? ''
      group1.department = store.state.inquiry.department ?? ''
      group1.postnumber = store.state.inquiry.postnumber ?? ''
      group1.address = store.state.inquiry.address ?? ''
      group1.address2 = store.state.inquiry.address2 ?? ''
      group1.address3 = store.state.inquiry.address3 ?? ''
      group1.address4 = store.state.inquiry.address4 ?? ''
      group1.email = store.state.inquiry.email ?? ''
      group1.email_check = store.state.inquiry.email_check ?? ''
      group1.occupation_classification = store.state.inquiry.occupation_classification ?? ''
      group1.occupation = store.state.inquiry.occupation ?? ''
      group1.tel = store.state.inquiry.tel ?? ''
      group1.tel2 = store.state.inquiry.tel2 ?? ''
      group1.extension = store.state.inquiry.extension ?? ''
      group1.fax = store.state.inquiry.fax ?? ''
      group1.message_type = store.state.inquiry.message_type ?? ''
      group1.message = store.state.inquiry.message ?? ''
      group1.occupationClassificationList = store.state.inquiry.occupationClassificationList ?? [] // 職業選択肢(プルダウン)生成用リスト

      if (group1.occupationClassificationList.length === 0) {
        // 職業選択肢表示用のデータをロード
        CommonInquiry.loadJobs(group1)
      }
    },

    /**
     * 住所取得
     * @param postnumber 郵便番号(半角数字7桁)
     * 
     */
    fetchAddresses: (postnumber) => {

      // 住所エリアを表示
      store.dispatch('inquiry/setAddressAreaVisible', true)

      // 住所データをロード
      CommonInquiry.loadAddresses(group1)
    },

    /**
     * 職業区分が選択された場合 → 職業区分に属する職業一覧を表示する
     */
    onOccupationClassificationListSelected: () => {

      // 表示していたプルダウンリストを非表示にする
      group1.displayOccupationClassificationSelect = false
    },

    /**
     * 職業が選択された場合
     */
    onOccupationListSelected: () => {

      // 表示していたプルダウンリストを非表示にする
      group1.displayOccupationSelect = false
    },

    /**
     * 住所選択ダイアログのサブミットボタンを押した場合
     */
    onPostnumberDuplicatedSubmitted: (eventMap) => {
      group1.address = eventMap.address ?? ''
      group1.address2 = eventMap.address2 ?? ''
      group1.visiblePostnumberDuplicated = false
    },

    /**
     * お問い合わせタイプが選択された場合 → お問い合わせタイプ一覧を表示する
     */
    onTypeListSelected: (selectedName) => {
      // 表示していたプルダウンリストを非表示にする
      group1.isVisibleTypeList = false

      // 選択したお問い合わせタイプをプルダウンに表示
      group1.message_type = selectedName
    },

    /**
     * 次へボタンを押下した時
     */
    submitButtonClicked: () => {

      if (group1.postnumber !== '') {
        // 郵便番号を入力したが、住所検索ボタンを押さず、住所エリアを表示しなかった場合に、
        // 住所エリアを表示させるための設定
        store.dispatch('inquiry/setAddressAreaVisible', true)
      }

      // 入力チェック
      const actionAfterCompletion = (group1, isError) => {

        group1.isError = isError

        if (group1.isError) {
          // 入力エラーが存在した場合

          // 画面の最上部にスクロールする
          common.scrollAreaTop('html')
          
          return false
        }

        // 入力値
        const inputParams = {
          name: group1.name,
          kana: group1.kana,
          charge_name: group1.charge_name,
          department: group1.department,
          postnumber: group1.postnumber,
          address: group1.address,
          address2: group1.address2,
          address3: group1.address3,
          address4: group1.address4,
          email: group1.email,
          email_check: group1.email_check,
          occupation_classification: group1.occupation_classification,
          occupation: group1.occupation,
          tel: group1.tel,
          tel2: group1.tel2,
          extension: group1.extension,
          fax: group1.fax,
          message_type: group1.message_type,
          message: group1.message,
          occupationClassificationList: group1.occupationClassificationList // 選択肢(プルダウン)生成用リスト
        }
    
        // ストアに入力値を保持
        store.dispatch('inquiry/setFormInputValues', inputParams)

        router.push({ path: '/public/inquiry/confirm' })
      }
      CommonInquiry.checkInput(group1, actionAfterCompletion)
    }
  })

  return group1
}

/**
 * 確認画面
 */
export const getGroupConfirm = () => {

  const group1 = reactive({
    // フォーム入力値
    name: '',
    kana: '',
    charge_name: '',
    department: '',
    postnumber: '',
    address: '',
    address2: '',
    address3: '',
    address4: '',
    email: '',

    occupation_classification: '', // 職業区分コード(文字列)
    occupation: '', // 業種・職業コード(文字列)

    // 職業選択肢(プルダウン)生成用リスト
    occupationClassificationList: [],

    // 選択された職業区分
    selectedOccupationClassificationName: computed(() => {
      return CommonInquiry.getSelectedOccupationClassificationName(group1, '')
    }),

    // 選択された業種・職業名
    selectedOccupationName: computed(() => {
      return CommonInquiry.getSelectedOccupationName(group1, '')
    }),

    tel: '',
    tel2: '',
    extension: '',
    fax: '',
    message_type: '',
    message: '',
    messageDisp: computed(() => {
      let value = group1.message
      value = common.escapeHTML(value)
      return value.replace(/\r?\n/g, '<br>')
    }),

    /**
     * 初期表示
     */
    init: () => {
      // ストアからデータをロード
      group1.name = store.state.inquiry.name ?? ''
      group1.kana = store.state.inquiry.kana ?? ''
      group1.charge_name = store.state.inquiry.charge_name ?? ''
      group1.department = store.state.inquiry.department ?? ''
      group1.postnumber = store.state.inquiry.postnumber ?? ''
      group1.address = store.state.inquiry.address ?? ''
      group1.address2 = store.state.inquiry.address2 ?? ''
      group1.address3 = store.state.inquiry.address3 ?? ''
      group1.address4 = store.state.inquiry.address4 ?? ''
      group1.email = store.state.inquiry.email ?? ''
      group1.occupation_classification = store.state.inquiry.occupation_classification ?? ''
      group1.occupation = store.state.inquiry.occupation ?? ''
      group1.tel = store.state.inquiry.tel ?? ''
      group1.tel2 = store.state.inquiry.tel2 ?? ''
      group1.extension = store.state.inquiry.extension ?? ''
      group1.fax = store.state.inquiry.fax ?? ''
      group1.message_type = store.state.inquiry.message_type ?? ''
      group1.message = store.state.inquiry.message ?? ''
      group1.occupationClassificationList = store.state.inquiry.occupationClassificationList ?? [] // 職業選択肢(プルダウン)生成用リスト

      if (group1.name === '') {
        router.push({ path: '/public/inquiry/index' })
      }
    },

    /**
     * 確定ボタンクリック時
     */
    onSubmitButtonClicked: () => {

      // 二重送信防止
      if (group1.isProcessing) {
        const payload = {
          title: '二重送信エラー',
          text: '短い時間に複数回送信ボタンが押されました。\n二重送信の可能性があるため、2度目以降の処理を中断します。'
        }
        store.dispatch('common/showNotice', payload)
        return
      }

      // 送信中フラグ（二重送信防止用）をtrueに設定
      group1.isProcessing = true

      // 画面リロードにより入力データが消えた場合に登録できないようにする。
      // 入力チェック
      const actionAfterCompletion = (group1, isError) => {

        if (isError) {
          // 入力エラーが存在した場合

          store.dispatch('common/showNotice', { title: 'エラー', text: '入力データが設定されていません。' })
          return false
        }

        // 無料トライアル・見積り＆お問い合わせ登録APIをコール

        const params = {
          type: 2, // 2=お問い合わせ（ログイン前）
          name: group1.name,
          kana: group1.kana,
          charge_name: group1.charge_name,
          department: group1.department,
          postnumber: group1.postnumber,
          address: group1.address,
          address2: group1.address2,
          address3: group1.address3,
          address4: group1.address4,
          email: group1.email,
          occupation_classification: group1.occupation_classification,
          occupation: group1.occupation,
          tel: group1.tel,
          tel2: group1.tel2,
          extension: group1.extension,
          fax: group1.fax,
          message_type: group1.message_type,
          message: group1.message,

          introducer: ''
        }

        store.dispatch('common/showLoading')
        apiInquiry.registerTrialEstimateInquiry(params)
          .then(response => {

            if (response) {
              const { data } = response

              if (data) {
                const status = data.status ?? -1

                if (status === 0) {
                  // 成功の場合
                  router.push({ path: '/public/inquiry/complete' })
                } else {
                  // エラーの場合
                  const errorMessageMap = data.validation_message ?? {}
                  const keys = Object.keys(errorMessageMap)
                  const errorMessages = []
                  for (let i = 0; i < keys.length; i++) {
                    const value = errorMessageMap[keys[i]]
                    errorMessages.push(value)
                  }
                  const errorMessage = errorMessages.join('\n')
                  store.dispatch('common/showNotice', { title: 'エラー', text: errorMessage })
                }
              }
            }
          })
          .finally(() => {
            // 送信中フラグ（二重送信防止用）をfalseに設定
            group1.isProcessing = false

            store.dispatch('common/hideLoading')
          })        
      }
      CommonInquiry.checkInput(group1, actionAfterCompletion)
    }
  })

  return group1
}


/**
 * 完了画面
 */
export const getGroupComplete = () => {

  const group1 = reactive({

    /**
     * 初期表示
     */
    init: () => {
      // ストアに保持している値を全クリア
      store.dispatch('inquiry/clearAllStates')
    }
  })

  return group1
}
